<template>
  <div>
    <b-alert
      v-model="showAlert"
     class="position-fixed fixed-top m-0 rounded-0"
      style="z-index: 2000;"
      :variant="alertValues.variant"
      dismissible
    >
      {{alertValues.errorMsg}}
    </b-alert>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: "AlertMessage",
  data() {
    return {
      showBottom: false,
      showTop: false,
    };
  },

computed: {
  showAlert: {
    get() {
     return this.$store.state.showAlert
    },
    set(value) {
      // MODIFY THIS MUTATION
      
      this.$store.commit("setShowAlert", value)
    }
  },
  ...mapState({
      alertValues: (state) => state.alertValues,
        
    })
},
};
</script>
<style scoped></style>
